"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Cross = function Cross(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 18 18'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-325.000000, -22.000000)',
    fill: 'currentColor'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(334.000000, 32.000000) rotate(45.000000) translate(-334.000000, -32.000000) translate(322.000000, 20.000000)'
  }, /*#__PURE__*/_react["default"].createElement('rect', {
    x: '0',
    y: '10',
    width: '23',
    height: '3',
    rx: '1.5'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    transform: 'translate(11.500000, 11.500000) rotate(90.000000) translate(-11.500000, -11.500000)',
    x: '0',
    y: '10',
    width: '23',
    height: '3',
    rx: '1.5'
  })))));
};
/* eslint-enable */
var _default = Cross;
exports["default"] = _default;